import React from 'react';

const LoadingSpinner: React.FC<{ label?: string }> = ({ label = 'Loading…' }) => (
  <div className="flex items-center justify-center gap-3 py-12 text-sm text-slate-500">
    <div className="h-5 w-5 rounded-full border-2 border-brand-500 border-t-transparent animate-spin" />
    <span>{label}</span>
  </div>
);

export default LoadingSpinner;
